import type { JSX, ReactNode } from 'react';
import { cn } from '@/lib/cn.js';

/**
 * Liste libellé → valeur des fiches de détail : libellés 12 px à gauche,
 * valeurs alignées sur une même colonne ; empilés sous `sm`.
 */
export function DescriptionList({
  className,
  children,
}: {
  className?: string | undefined;
  children: ReactNode;
}): JSX.Element {
  return (
    <dl
      className={cn(
        'grid grid-cols-1 gap-x-6 gap-y-3 sm:grid-cols-[minmax(9rem,max-content)_minmax(0,1fr)]',
        className,
      )}
    >
      {children}
    </dl>
  );
}

export interface DescriptionItemProps {
  label: ReactNode;
  children: ReactNode;
  className?: string | undefined;
}

export function DescriptionItem({ label, children, className }: DescriptionItemProps): JSX.Element {
  return (
    <div className={cn('flex flex-col gap-0.5 sm:contents', className)}>
      <dt className="text-xs font-medium leading-5 text-muted-foreground sm:pt-px">{label}</dt>
      <dd className="min-w-0 break-words text-sm text-foreground">{children}</dd>
    </div>
  );
}
